import DialogManager from "@/utils/DialogManager";
import Rpc from "@/Rpc";
import ActivityManager from "@/activity/ActivityManager";
import {sendEvent} from "@/utils/GEvents";

export async function sketch2Photo(prompt, {
    saveImage, onProgress = () => {
    }, savePlaceholderToGallery = () => {
    }
}) {
    sendEvent("sketch2Pht-start");
    try {
        const file = await saveImage();

        if (!prompt) {
            prompt = await DialogManager.textarea(
                $tr('aiSketch2Img-title', 'Sketch to Image'),
                $tr('aiSketch2Img-prompt', 'Describe the final effect'),
                false
            );
            if (!prompt?.trim()) {
                return null;
            }
        }


        const newImageFile = await Rpc.BusinessEntities.uploadImage(file, "tmp-sketch").lock();

        let progressValue = 0;
        await savePlaceholderToGallery();
        const task = await Rpc.PaintingTools.sketchToPhoto(newImageFile, prompt);
        task.onPartialResult(progress => {
            const newProgress = progress[0]?.progress ?? 0;
            if (newProgress > progressValue) {
                progressValue = newProgress;
                onProgress(progressValue);
            }
        });
        const newImageBase64 = await task.finish();
        return 'data:image/jpg;base64,' + newImageBase64[0];
    } catch (e) {
        console.error("Error in Sketch to photo: ", e);
        return null;
    }
}

export async function draft2Project({
                                        saveImage, onProgress = () => {
    }, savePlaceholderToGallery = () => {
    }
                                    }) {
    const prompt = await DialogManager.textarea(
        $tr('draft2Project-title', 'Draft to Project'),
        $tr('draft2Project-prompt', 'Describe the drafted product'),
        false
    );
    if (!prompt?.trim()) {
        return null;
    }

    sendEvent("draft2Prj-start");

    const file = await saveImage();
    const newImageFile = await Rpc.BusinessEntities.uploadImage(file, "tmp-sketch").lock();

    let progressValue = 0;
    await savePlaceholderToGallery();
    const task = await Rpc.PaintingTools.scribblesToProject(newImageFile, prompt);
    task.onPartialResult(progress => {
        const newProgress = progress[0]?.progress ?? 0;
        if (newProgress > progressValue) {
            progressValue = newProgress;
            onProgress(progressValue);
        }
    });
    const newImageBase64 = await task.finish();
    return 'data:image/jpg;base64,' + newImageBase64[0];
}

export async function AISketch({
                                   saveImage, onProgress = () => {
    }, savePlaceholderToGallery = () => {
    }
                               }) {
    sendEvent("inpnt-start");
    try {
        const file = await saveImage();
        const newImageFile = await Rpc.BusinessEntities.uploadImage(file, "tmp-sketch").lock();

        const AISketchModule = await import("@/components/img/AISketch.vue");
        const AISketchComponent = AISketchModule.default || AISketchModule;

        const AISketchActivity = await ActivityManager.showActivity(AISketchComponent, {
            imageSrc: newImageFile.url,
            descriptionTask: null
        });

        const result = await AISketchActivity.getResult();
        if (result) {
            await savePlaceholderToGallery();
            let progressValue = 0;
            const task = await Rpc.PaintingTools.inPaint(newImageFile, result.mask, result.prompt);
            task.onPartialResult(progress => {
                const newProgress = progress[0]?.progress ?? 0;
                if (newProgress > progressValue) {
                    progressValue = newProgress;
                    onProgress(progressValue);
                }
            });
            const newImageBase64 = await task.finish();
            return 'data:image/jpg;base64,' + newImageBase64[0];
        }
        return null;
    } catch (e) {
        console.error("Error in AISketch:", e);
        return null;
    }
}


export async function generateProductWithThreePoses(prompt, {
    onProgress = () => {
    }, savePlaceholderToGallery = () => {
    }
}) {
    let progressValue = 0;
    await savePlaceholderToGallery();
    const task = await Rpc.ai.GenerateImageByAI.generateProductWithThreePoses(prompt);
    task.onPartialResult(progress => {
        const newProgress = progress[0]?.progress ?? 0;
        if (newProgress > progressValue) {
            progressValue = newProgress;
            onProgress(progressValue);
        }
    });
    let listOfImagesBase64 = [];
    const listOfImagesBase64FromTask = await task.finish();
    for (let base64 of listOfImagesBase64FromTask){
        base64 = 'data:image/jpg;base64,' + base64;
        listOfImagesBase64.push(base64)
    }
    return listOfImagesBase64;
}
